import React from "react";
import Grid from "@mui/material/Grid";
import useStyles from "./landingStyle-jss";
import Title from "./Title";
import sson from "../../images/services/sso-new.webp";
import vlabs from "../../images/services/vlabs.webp";
import cdac from "../../images/services/service.webp";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import featureAnimation from "/app/images/featureImage.webp";
import featureImgInside from "/app/images/insideFeatureImg.webp";
import allFeaturesImg from "/app/images/features/digital_nagriks.webp";
import AppSettingsAltOutlinedIcon from "@mui/icons-material/AppSettingsAltOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import "./Landing.css";

const OurFeaturtes = (props) => {
  const { slideMode } = props;
  const { classes, cx } = useStyles();
  return (
    <div className="my-5 servicesSection">
      {/* <div className={cx(classes.container)}>
        <Grid
          container
          spacing={4}
          className={` gridContainer ${classes.root}`}
        >
          <Grid md={3}>
            <div>cnjnsca</div>
            <div>cnjnsca</div>
            <div>cnjnsca</div>
          </Grid>
        </Grid>

      </div> */}
      <div className={slideMode ? classes.fullWidth : classes.container}>
        <Title
          title="Features"
          desc="Features that our platform will provide"
          align="left"
          monocolor={slideMode && true}
        />
        {/* <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="Heading text-center">
                <h2>Service </h2>
              </div>
            </div>
          </div>
        </div> */}
        <Grid container spacing={2}>
          <Grid item md={6}>
            <Typography component="p" variant="p">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </Typography>
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <div className={classes.featureList}>
                  <ul>
                    <li className={classes.featureListItem}>
                      <div
                        className={`d-flex align-items-center ${classes.FeatureListItemDiv}`}
                      >
                        <span>
                          <Avatar className={classes.avatarGreen}>
                            <AppSettingsAltOutlinedIcon />
                          </Avatar>
                        </span>
                        <div className="px-3">Mobile Security</div>
                      </div>
                    </li>
                    <li className={classes.featureListItem}>
                      <div
                        className={`d-flex align-items-center ${classes.FeatureListItemDiv}`}
                      >
                        <span>
                          <Avatar className={classes.avatarGreen}>
                            <AppSettingsAltOutlinedIcon />
                          </Avatar>
                        </span>
                        <div className="px-3">Cyber Security</div>
                      </div>
                    </li>
                    <li className={classes.featureListItem}>
                      <div
                        className={`d-flex align-items-center ${classes.FeatureListItemDiv}`}
                      >
                        <span>
                          <Avatar className={classes.avatarGreen}>
                            <AppSettingsAltOutlinedIcon />
                          </Avatar>
                        </span>
                        <div className="px-3">Learning</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div className={classes.featureList}>
                  <ul>
                    <li className={classes.featureListItem}>
                      <div
                        className={`d-flex align-items-center ${classes.FeatureListItemDiv}`}
                      >
                        <span>
                          <Avatar className={classes.avatarGreen}>
                            <LanguageOutlinedIcon />
                          </Avatar>
                        </span>
                        <div className="px-3">Web Security</div>
                      </div>
                    </li>
                    <li className={classes.featureListItem}>
                      <div
                        className={`d-flex align-items-center ${classes.FeatureListItemDiv}`}
                      >
                        <span>
                          <Avatar className={classes.avatarGreen}>
                            <LanguageOutlinedIcon />
                          </Avatar>
                        </span>
                        <div className="px-3">Staye Safe Online</div>
                      </div>
                    </li>
                    <li className={classes.featureListItem}>
                      <div
                        className={`d-flex align-items-center ${classes.FeatureListItemDiv}`}
                      >
                        <span>
                          <Avatar className={classes.avatarGreen}>
                            <LanguageOutlinedIcon />
                          </Avatar>
                        </span>
                        <div className="px-3">Infosec Awareness</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={6}>
            <div className="services-right-image">
              <img
                src={featureAnimation}
                className="bg-image rotateme"
                alt="shape"
              />
              {/* <img src={featureImgInside} alt="main-pic" /> */}
              <img
                src={allFeaturesImg}
                alt="main-pic"
                className="featurtesImg"
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default OurFeaturtes;
